import { PasswordPolicy } from '../constants'

export const PasswordRules = {
  MIN_LENGTH: 'minLength',
  MAX_LENGTH: 'maxLength',
  LOWERCASE: 'lowercase',
  UPPERCASE: 'uppercase',
  NUMBER: 'number'
}

// Size of a text once encoded as UTF-8, the way the API hashes it.
function getByteLength(text) {
  return new TextEncoder().encode(text).length
}

// Returns the rules a password breaks (empty if it's valid). Mirrors the API validation: length
// counts characters, and letter case works for any alphabet (e.g. 'Ñ').
export function getPasswordErrors(password = '') {
  const errors = []
  const length = Array.from(password).length
  if (length < PasswordPolicy.minLength) {
    errors.push(PasswordRules.MIN_LENGTH)
  }

  if (length > PasswordPolicy.maxLength || getByteLength(password) > PasswordPolicy.maxBytes) {
    errors.push(PasswordRules.MAX_LENGTH)
  }

  if (password === password.toUpperCase()) {
    errors.push(PasswordRules.LOWERCASE)
  }

  if (password === password.toLowerCase()) {
    errors.push(PasswordRules.UPPERCASE)
  }

  if (!/[0-9]/.test(password)) {
    errors.push(PasswordRules.NUMBER)
  }

  return errors
}

// How many characters of the password fit in the limits, counted from the start. Fewer than the
// maximum length when it has characters that take several bytes (e.g. 'ñ' or '中').
export function getFittingLength(password = '') {
  const chars = Array.from(password)
  let bytes = 0
  let length = 0
  while (length < chars.length && length < PasswordPolicy.maxLength) {
    bytes += getByteLength(chars[length])
    if (bytes > PasswordPolicy.maxBytes) {
      break
    }

    length += 1
  }

  return length
}
